import React from "react";

const FIRE_STATUS = {
  ok:               { label: "Correcte",          cls: "bg-green-100 text-green-700" },
  pending_revision: { label: "Revisió pendent",   cls: "bg-yellow-100 text-yellow-700" },
  expired:          { label: "Caducada",           cls: "bg-red-100 text-red-700" },
  deficient:        { label: "Deficient",          cls: "bg-orange-100 text-orange-700" },
  inactive:         { label: "Inactiu",            cls: "bg-gray-100 text-gray-500" },
};

const GAS_STATUS = {
  ok:                 { label: "Correcte",          cls: "bg-green-100 text-green-700" },
  pending_inspection: { label: "Inspecció pendent", cls: "bg-yellow-100 text-yellow-700" },
  expired:            { label: "Caducada",          cls: "bg-red-100 text-red-700" },
  incident_open:      { label: "Incidència oberta", cls: "bg-red-100 text-red-700" },
  inactive:           { label: "Inactiu",           cls: "bg-gray-100 text-gray-500" },
};

const EQUIP_STATUS = {
  operatiu:       { label: "Operatiu",        cls: "bg-green-100 text-green-700" },
  en_manteniment: { label: "En manteniment",  cls: "bg-yellow-100 text-yellow-700" },
  avariat:        { label: "Avariat",         cls: "bg-red-100 text-red-700" },
  baixa:          { label: "Baixa",           cls: "bg-gray-100 text-gray-500" },
};

const MAINT_RESULT = {
  favorable:            { label: "Favorable",            cls: "bg-green-100 text-green-700" },
  favorable_condicions: { label: "Fav. amb condicions",  cls: "bg-yellow-100 text-yellow-700" },
  desfavorable:         { label: "Desfavorable",         cls: "bg-red-100 text-red-700" },
  pendent:              { label: "Pendent",              cls: "bg-gray-100 text-gray-500" },
};

function Badge({ map, value }) {
  const cfg = map[value] || { label: value || "—", cls: "bg-gray-100 text-gray-500" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${cfg.cls}`}>
      {cfg.label}
    </span>
  );
}

export const FireStatusBadge   = ({ status })  => <Badge map={FIRE_STATUS}  value={status} />;
export const GasStatusBadge    = ({ status })  => <Badge map={GAS_STATUS}   value={status} />;
export const EquipStatusBadge  = ({ status })  => <Badge map={EQUIP_STATUS} value={status} />;
export const MaintResultBadge  = ({ result })  => <Badge map={MAINT_RESULT} value={result} />;

export const FIRE_STATUS_MAP  = FIRE_STATUS;
export const GAS_STATUS_MAP   = GAS_STATUS;
export const EQUIP_STATUS_MAP = EQUIP_STATUS;